import { Theme } from '@material-ui/core/styles';

export default (theme: Theme): Theme =>
  (theme = {
    ...theme,
    direction: 'ltr',
    overrides: {
      ...theme.overrides,
      MuiInputLabel: (theme.overrides as any)?.MuiInputLabel
        ? {
            ...(theme.overrides as any).MuiInputLabel,
            '&$shrink': { transformOrigin: 'top left !important' },
          }
        : ({} as any),
      MuiListItemSecondaryAction: {
        root: {
          right: 16,
          left: 'unset',
        },
      },
      MuiListItem: {
        root: {
          textAlign: 'left',
          direction: 'ltr',
        },
      },
    },
  });
